import React, { memo } from 'react';

import { betBg_logo, efbet_logo } from 'assets';
import { IS_EFBET } from 'services/constants';

import classes from './logoIcon.module.scss';

const LogoIcon = ({ containerStyle, imageStyle }) => (
  <div className={containerStyle ? containerStyle : classes.Container}>
    <img
      src={IS_EFBET ? efbet_logo : betBg_logo}
      alt="logo"
      className={imageStyle ? imageStyle : classes.Image}
    />
  </div>
);

export default memo(LogoIcon);
